import { UniversityStudyRoomTemplate } from "@/components/UniversityStudyRoomTemplate";

const HumberCollege = () => {
  return (
    <UniversityStudyRoomTemplate
      universityName="Humber College"
      universityShortName="Humber"
      slug="humber-college"
      seoTitle="Humber College Study Rooms | North Campus Library Study Guide"
      seoDescription="Complete guide to study rooms at Humber College. Find North Library, Learning Resource Commons, and Idea Lab study spaces. Plus free 24/7 online alternative."
      seoKeywords="humber college study rooms, humber library, north campus library, learning resource commons, humber lrc, humber study spaces"
      canonicalUrl="/study-room/humber-college/"
      heroDescription="A comprehensive guide to study rooms and spaces at Humber College, including the North Library and Learning Resource Commons."
      libraryWebsiteUrl="https://library.humber.ca/"
      libraryWebsiteName="Humber Libraries"
      studySpaces={[
        {
          name: "North Library and North Learning Commons",
          features: "Provide bookable group study rooms, quiet study rooms, individual seating, computer workstations and an Adaptive Technology Room. Policies encourage moderate-to-low conversation and headphone use.",
          feedback: "Many students appreciate the open policy allowing food and group study. However, some complain that group areas are noisy and that there isn't a dedicated silent floor."
        },
        {
          name: "LRC 4th Floor",
          features: "Upper floor of the Learning Resource Commons with study seating.",
          feedback: "Students criticize the 4th floor for being 'louder than the hallways'; groups occupy tables to socialize, forcing others to wear headphones."
        },
        {
          name: "Idea Lab",
          features: "Media studios and fabrication tools for creative and technical projects.",
          feedback: "Not meant for silent study but offers creativity and hands-on learning opportunities."
        },
        {
          name: "Indigenous Cultural Spaces",
          features: "Unique spaces including pillars painted by Ojibwe artist Patrick Hunter for cultural engagement.",
          feedback: "These spaces are not meant for silent study but offer cultural engagement and community connection."
        },
        {
          name: "Quiet Study Rooms",
          features: "Bookable rooms for individuals or small groups seeking a quieter environment.",
          feedback: "Must be booked in advance; availability can be limited during busy periods."
        }
      ]}
      guideContent={
        <>
          <p className="mb-4">
            Humber's <strong>Learning Resource Commons</strong> is designed for collaboration and inclusivity. You can reserve group rooms or work in open areas that allow food and conversation.
          </p>
          <p className="mb-4">
            The library's noise policy relies on users being considerate rather than enforcing silence, which means that <strong>some areas feel more like a cafeteria than a library</strong>. For quiet work, book a group room or seek out less populated sections on upper floors.
          </p>
          <p>
            If you need creative tools or want to explore Indigenous art, take a break in the <strong>Idea Lab</strong> or view the cultural installations. To ensure a productive session, bring headphones and arrive early to secure a suitable spot.
          </p>
        </>
      }
      summaryTips={[
        "Book quiet rooms in advance: Open areas can be noisy, so reserve a quiet room for focused work.",
        "Avoid LRC 4th floor for quiet study: Despite being upper floor, it's often louder than expected.",
        "Bring headphones: The noise policy is lenient, so expect ambient conversation everywhere.",
        "Arrive early: Good spots fill up quickly, especially during exam periods.",
        "Use CSW for guaranteed silence: Virtual study rooms offer a consistently quiet environment when Humber is too loud."
      ]}
    />
  );
};

export default HumberCollege;
